import { EXPLORE_GROUPS_ROUTE_NAME, EXPLORE_GROUPS_TABS } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/explore/groups/constants.js?vue3';
import ExploreGroupsApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/explore/groups/components/app.vue?vue3';

export default [
  {
    name: EXPLORE_GROUPS_ROUTE_NAME,
    path: '/',
    component: ExploreGroupsApp,
  },
  ...EXPLORE_GROUPS_TABS.map(({ value }) => ({
    name: value,
    path: `/${value}`,
    component: ExploreGroupsApp,
  })),
];
